(function () {
  var ENHANCED_CLASS = 'rewards-page-shell--ready';
  var MAX_ATTEMPTS = 60;
  var attempt = 0;

  function getHeaderOffset() {
    var header = document.querySelector(
      '.shopify-section-group-group-header [data-sticky-scroll-header-banner-mobile], ' +
        '.shopify-section-group-group-header [data-sticky-scroll-header-banner-desktop], ' +
        '.shopify-section-group-group-header ce-sticky-scroll-header, ' +
        '.shopify-section-group-group-header header'
    );

    if (!header) return 0;
    return Math.ceil(header.getBoundingClientRect().height || 0);
  }

  function setStickyOffset() {
    document.documentElement.style.setProperty('--rewards-sticky-top', getHeaderOffset() + 'px');
  }

  function findHeroContainer(pageContainer) {
    var heroWidget = pageContainer.querySelector('.yotpo-widget-hero-section');
    if (!heroWidget) return null;
    return heroWidget.closest('.yotpo-widget-instance-container') || heroWidget.parentElement;
  }

  function enhanceRewardsPage(shell) {
    var pageContainer = document.querySelector('.yotpo-loyalty-page-container');
    if (!pageContainer) return false;

    var heroContainer = findHeroContainer(pageContainer);
    if (!heroContainer) return false;

    if (pageContainer.firstElementChild !== heroContainer) {
      pageContainer.insertBefore(heroContainer, pageContainer.firstElementChild);
    }

    shell.classList.add(ENHANCED_CLASS);
    setStickyOffset();
    return true;
  }

  function init() {
    var shell = document.querySelector('[data-rewards-page-shell]');
    if (!shell) return;

    setStickyOffset();
    window.addEventListener('resize', setStickyOffset, { passive: true });

    if (enhanceRewardsPage(shell)) return;

    var observer = new MutationObserver(function () {
      attempt += 1;
      if (enhanceRewardsPage(shell) || attempt >= MAX_ATTEMPTS) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
